export default __webpack_public_path__ + "static/media/teacher_pic1.9234a9b4.png";